var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/HeaderLogo/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Logo, LogoWithText } from '../../../Logos';
import useStyles from './useHeaderLogoStyles';
var HeaderLogo = function HeaderLogo(_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    isUserAuthenticated = _ref.isUserAuthenticated;
  var auth = isUserAuthenticated ? 'auth' : 'anon';
  var _useStyles = useStyles(),
    LogoLink = _useStyles.LogoLink,
    LogoAuthIcon = _useStyles.LogoAuthIcon,
    LogoAnonIcon = _useStyles.LogoAnonIcon,
    LogoText = _useStyles.LogoText;
  return /*#__PURE__*/React.createElement("a", {
    href: "/",
    alt: "SurveyMonkey Logo",
    className: "".concat(LogoLink, " ").concat(auth, "--").concat(variant),
    "data-testid": "Logo-Link_".concat(auth, "--").concat(variant),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, !isUserAuthenticated ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: LogoText,
    "data-testid": "Logo-Text_".concat(auth, "--").concat(variant),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(LogoWithText, {
    color: color,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Logo, {
    color: color,
    className: LogoAnonIcon,
    "data-testid": "Logo-Anon-Icon_".concat(auth, "--").concat(variant),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(Logo, {
    className: LogoAuthIcon,
    color: "alt",
    "data-testid": "Logo-Auth-Icon_".concat(auth, "--").concat(variant),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 11
    }
  }));
};
HeaderLogo.propTypes = {
  isUserAuthenticated: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'alt']),
  variant: PropTypes.oneOf(['default', 'limited', 'slim'])
};
HeaderLogo.defaultProps = {
  isUserAuthenticated: false,
  color: 'primary',
  variant: 'default'
};
export default HeaderLogo;
//# sourceMappingURL=index.js.map